/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
// components
import CategoryStrip from "../components/CategoryStrip";
import TextCard from "../components/TextCard";
import withUrlSortParam from "../components/withUrlSortParam";
// helpers + selectors
import { generateSEOGroupLink, generateSEOGroupCategoryLink } from "../helpers/linkGenerators";
import { slugify } from "../helpers/misc";
import { getCategoriesForGroupCards, getSelectedCityName } from "../selectors/index";
import { categoryToggleLink, categoryToggleListItem } from "../styles/toggleFilterStyles";
const mapStateToProps = (state, props) => {
    const selectedCity = getSelectedCityName(state);
    const { category, group, sortValue, timeFilter, priceFilter, typeValue, maxPrice } = props;
    const groupName = group.get("name");
    const source = groupName;
    const categories = getCategoriesForGroupCards(state, props);
    const links = categories.map(c => ({
        href: generateSEOGroupCategoryLink(selectedCity, c.get("name"), groupName, timeFilter, sortValue, priceFilter, typeValue, maxPrice),
        name: c.get("name"),
        count: c.get("eventCount")
    }));
    const allCard = (<li css={css(categoryToggleListItem)} key="all-link">
			<TextCard activeClassName="active" activeOverride={true} css={css(categoryToggleLink)} href={generateSEOGroupLink(selectedCity, groupName, timeFilter, sortValue, priceFilter, typeValue, maxPrice)} matchWithoutQueryParams={true} text={`All ${groupName}`}/>
		</li>);
    if (category) {
        const selectedCategory = categories.find(c => {
            return slugify(c.get("name")) === encodeURIComponent(category);
        });
        if (selectedCategory) {
            const selected = {
                href: generateSEOGroupCategoryLink(selectedCity, selectedCategory.get("name"), groupName, timeFilter, sortValue, priceFilter, typeValue, maxPrice),
                name: selectedCategory.get("name"),
                count: selectedCategory.get("eventCount")
            };
            return {
                allCard,
                links,
                selected,
                selectedCity,
                source
            };
        }
    }
    return {
        allCard,
        links,
        selectedCity,
        source
    };
};
export default withUrlSortParam(connect(mapStateToProps)(CategoryStrip));
